<template>
  <div class="youkexianxiaxingweifenxi">
    <IconList :list="list" :marginBottom="0.3" />
  </div>
</template>

<script>
import IconList from "@/components/Mycharts/IconList.vue";

export default {
  name: "YoukeXianxiaXingweiFenxi",
  components: {
    IconList
  },
  props: {
    data: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      list: [
        {
          listName: "停留时间",
          listIcon: require("../../assets/youkexianxiaxingweifenxi/icon1.png"),
          code: 102,
          offsetY: -380
        },
        {
          listName: "交通方式",
          listIcon: require("../../assets/youkexianxiaxingweifenxi/icon2.png"),
          code: 102,
          offsetY: -1100
        },
        {
          listName: "消费潜力",
          listIcon: require("../../assets/youkexianxiaxingweifenxi/icon3.png"),
          code: 102,
          offsetY: -1300
        },
        {
          listName: "隔夜分析",
          listIcon: require("../../assets/youkexianxiaxingweifenxi/icon4.png"),
          code: 102,
          offsetY: 0
        },
        {
          listName: "出游距离",
          listIcon: require("../../assets/youkexianxiaxingweifenxi/icon5.png"),
          code: 102,
          offsetY: -2000
        },
        {
          listName: "住宿热图",
          listIcon: require("../../assets/youkexianxiaxingweifenxi/icon6.png"),
          code: 102,
          offsetY: -700
        }
      ]
    };
  },
  mounted() {}
};
</script>

<style scoped lang="less"></style>
